import { Component, input, output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { FormCheckboxComponent } from "../../form";

export type TableLegendCheckbox = "options" | "targets" | "calculation";

@Component({
  selector: "adaa-table-legend-data-entry",
  imports: [TranslatePipe, FormCheckboxComponent],
  templateUrl: "./table-legend-data-entry.html",
  styleUrl: "./table-legend-data-entry.scss",
})
export class TableLegendDataEntryComponent {
  title = input<string>("data_entry.actuals");
  showCalculation = input<boolean>(false);
  hasAuditIssue = input<boolean>(false);
  showActions = input<boolean>(true);
  showOptions = input<boolean>(true);

  checkboxClicked = output<{ checkbox: TableLegendCheckbox; checked: boolean }>();
}
